export default {
  locale: 'en'
}
